import React, { useState, useEffect } from 'react'

import { useAppSelector } from 'app-redux/hooks'

import MultiSelectDropdown from 'components/formElements/MultiSelectDropdown'

const options = [
  { value: 'Basic', label: 'Basic', searchString: 'Basic' },
  { value: 'Legendary', label: 'Legendary', searchString: 'Legendary' },
  { value: 'Ongoing', label: 'Ongoing', searchString: 'Ongoing' },
  { value: 'Snow', label: 'Snow', searchString: 'Snow' },
  { value: 'World', label: 'World', searchString: 'World' },
]

type Props = {
  onChange: (values: string[]) => void
  value?: string[]
}

const SuperTypeDropdown = ({ value, onChange }: Props) => {
  const isMobile = useAppSelector(state => state.active.isMobile)

  const [selectedOptions, setSelectedOptions] = useState(value ?? new Array<string>())

  // Used to reset the form
  useEffect(() => {
    if (!value || !value?.length) setSelectedOptions([])
  }, [value])

  const handleChange = (selectedOptions: string[]) => {
    setSelectedOptions(selectedOptions)
    onChange(selectedOptions)
  }

  return (
    <MultiSelectDropdown
      searchable={!isMobile}
      placeholder="Supertype (eg: Basic)"
      onChange={handleChange}
      options={options}
      value={selectedOptions}
    />
  )
}

export default SuperTypeDropdown
